/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFeaturedInWithLogosCf052Fragment} from '@amblique/contentful/app/contentful/fragments/featured-in-with-logos-cf052/base-featured-in-with-logos-cf052.fragment';
import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';

export const FeaturedInWithLogosCf052Fragment = gql`
  ${BaseFeaturedInWithLogosCf052Fragment}
  ${BaseIconFragment}

  fragment FeaturedInWithLogosCf052Fragment on FeaturedInWithLogosCf052 {
    ...BaseFeaturedInWithLogosCf052Fragment

    iconsCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
    iconsCursorCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
  }
`;
